import { useEffect, useState } from "react"

const FetchQBData = (urlRoot, qbs) => {

    const [qbData, setQbData] = useState(['Loading']);

    useEffect(() => {

        var fetchUrl = urlRoot

        for (const qb in qbs) {
            if (parseInt(qb) === 0) {
                fetchUrl = fetchUrl + '?qb=' + qbs[qb]['value']
            } else {
                fetchUrl = fetchUrl + '&qb=' + qbs[qb]['value']
            }
        }

        fetchData(fetchUrl)

    }, [urlRoot, qbs])

    const fetchData = async (fetchUrl) => {
        await fetch(fetchUrl).then(
            response => response.json()
        ).then(data => {
            setQbData(data)
        })
    }

    return qbData

}


export default FetchQBData